import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from "react";
import Helmet from "react-helmet";
function SEO(props) {
    var metaDescription = props.description || "poepoe.org";
    var metaTitle = props.title || "poepoe.org";
    return /*#__PURE__*/ React.createElement(Helmet, {
        htmlAttributes: {
            lang: "en"
        },
        title: props.title,
        titleTemplate: props.title ? "%s | poepoe.org" : "poepoe.org",
        meta: [{
                name: "description",
                content: metaDescription
            }, {
                property: "og:title",
                content: props.title
            }, {
                property: "og:description",
                content: metaDescription
            }, {
                property: "og:type",
                content: "website"
            }, {
                property: "og:image",
                content: "/images/favicon.png"
            }].concat(_toConsumableArray(props.meta || []))
    });
}
export default SEO;
